import "virtual-livereload";
import $ from "jquery";
import "./components";

window.$ = $;
window.jQuery = $;
